window.Unigine = {};

$(window).on('load', function() {
  var $body = $('body');
  $body.addClass('loaded');
  $body.removeClass('loading');
});

/*Some legacy trash*/
$.fn.modal.Constructor.prototype.enforceFocus = function() {
  var modal_this = this;
  $(document).on('focusin.modal', function(e) {
    if (modal_this.$element[0] !== e.target &&
      !modal_this.$element.has(e.target).length
      && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_select')
      && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_textarea')
      && !$(e.target.parentNode).hasClass('cke_dialog_ui_input_text')) {
      modal_this.$element.focus();
    }
  });
};

$.fn.shake = function(options) {
  // defaults
  var settings = {
    'shakes': 2,
    'distance': 10,
    'duration': 400,
  };
  // merge options
  if (options) {
    $.extend(settings, options);
  }
  // make it so
  var pos;
  return this.each(function() {
    $this = $(this);
    // position if necessary
    pos = $this.css('position');
    if (!pos || pos === 'static') {
      $this.css('position', 'relative');
    }
    // shake it
    for (var x = 1; x <= settings.shakes; x++) {
      $this.animate({left: settings.distance * -1},
        (settings.duration / settings.shakes) / 4).
        animate({left: settings.distance},
          (settings.duration / settings.shakes) / 2).
        animate({left: 0}, (settings.duration / settings.shakes) / 4);
    }
  });
};

$.fn.toggleOption = function(show) {
  jQuery(this).toggle(show);
  if (show) {
    if (jQuery(this).parent('span.toggleOption').length)
      jQuery(this).unwrap();
  }
  else {
    if (jQuery(this).parent('span.toggleOption').length === 0)
      jQuery(this).
        wrap('<span class="toggleOption" style="display: none;" />');
  }
};

$(function() {
  var $leftPanel = $('.container .left-panel');
  var $leftPanelOpener = $('.js-left-panel-opener');
  var $header = $('.js-header');
  var $footer = $('#footer');
  var headerHeightScroll = $header.height();

  var scrollPosition;
  var windowHeight;
  var beforeEnd;

  var initHeightLeftPanel = $leftPanel.innerHeight();

  /*Window changing*/
  $(window).on('load resize scroll', function() {
    scrollPosition = document.body.scrollTop +
      document.documentElement.scrollTop;
    windowHeight = $(window).height();
    headerHeightScroll = $header.height();
    beforeEnd = $(document).height() - (scrollPosition + windowHeight);

    if (scrollPosition > headerHeightScroll) {
      $leftPanel.css({'top' : 0});
      $leftPanel.css({'height': 'inherit'});
      // $leftPanel.css({'padding-bottom': (62 - beforeEnd)});
      $leftPanelOpener.addClass('stick');

      if (62 - beforeEnd > 0) {
        $leftPanel.css({'bottom': (62 - beforeEnd)});
      } else {
        $leftPanel.css({'bottom': '0'});
      }
      
      $leftPanel.addClass('stick');
      $('#jump-up').show();
      $('#lang-selector').addClass('stick');
      $('.js-docs-outdated-warning').addClass('stick');
      $('.js-docs-unsupported-warning').addClass('stick');
      $('.search-highlight-button').addClass('stick');
      $('.js-prec-selector-btn').addClass('stick');
      $('body').addClass('has-stick');
    }
    else {
      $leftPanel.css({'top': headerHeightScroll - scrollPosition});
      $leftPanel.css({'height': 'calc(100vh - ' + (headerHeightScroll - scrollPosition) + 'px)'});
      $leftPanel.css({'padding-bottom': 10});

      $leftPanel.removeClass('stick');
      $leftPanelOpener.removeClass('stick');
      $('#jump-up').hide();
      $('#lang-selector').removeClass('stick');
      $('.js-docs-outdated-warning').removeClass('stick');
      $('.js-docs-unsupported-warning').removeClass('stick');
      $('.search-highlight-button').removeClass('stick');
      $('.js-prec-selector-btn').removeClass('stick');
      $('body').removeClass('has-stick');
    }
  });

  /*Mobile interaction*/
  // $('.js-btn-menu-open').on('click', function() {
  //   $('.js-navigation').addClass('show');
  // });

  var initHamburger = function() {
    var openButton = document.querySelector('.js-btn-menu-open');
    var mobileMenuWrapper = document.querySelector('.js-navigation');
    var layout = document.querySelector('.js-navigation-mobile-layout');
    var closeButton = mobileMenuWrapper.querySelector('.js-btn-menu-close');
    var body = document.querySelector('body');
  
    var openMenu = function() {
      mobileMenuWrapper.classList.add('_opened');
      layout.classList.add('_opened');
      body.classList.add('disable-scroll');
    };
  
    var closeMenu = function() {
      mobileMenuWrapper.classList.remove('_opened');
      layout.classList.remove('_opened');
      body.classList.remove('disable-scroll');
    };
  
    openButton.addEventListener('click', function(e) {
      openMenu();
    });
  
    closeButton.addEventListener('click', function(e) {
      closeMenu();
    });
  
    layout.addEventListener('click', function(e) {
      closeMenu();
    });
  };

  initHamburger();

  $leftPanelOpener.on('click', function() {
    $leftPanel.toggleClass('open');
    $leftPanelOpener.toggleClass('open');
  });

  // $('.js-btn-menu-close').on('click', function() {
  //   $('.js-navigation').removeClass('show');
  // });

  /*Show/hide docs versions in menu*/
  var $parentMenu = $('.js-expandable-items');

  $parentMenu.each(function() {
    var $parent = $(this);
    var $buttonHide = $parent.find('.btn-items-hide');
    var btnStatuses = $buttonHide.text().split('|');
    var curStatus = false;
    $buttonHide.text(btnStatuses[+curStatus])

    $parent.find('.btn-items-hide').on('click', function(e) {
      e.preventDefault();
      $parent.toggleClass('items-hidden');
      curStatus = !curStatus;
      $buttonHide.text(btnStatuses[+curStatus]);
    });
  });


  // var $buttonHide = $parentMenu.find('.btn-items-hide');
  // var btnStatuses = $buttonHide.text().split('|');
  // var curStatus = false;
  // $buttonHide.text(btnStatuses[+curStatus])

  // $('.js-expandable-items .btn-items-hide').on('click', function(e) {
  //   e.preventDefault();
  //   $parentMenu.toggleClass('items-hidden');
  //   curStatus = !curStatus;
  //   $buttonHide.text(btnStatuses[+curStatus]);
  // });

  var unsupportedVersions = ['2.10', '2.9', '2.8', '2.7.3', '2.7.2', '2.7.1', '2.7', '2.6.1', '2.6', '2.5', '2.4.1', '2.4', '2.3.1', '2.3', '2.2.1', '2.2', '2.1.1', '2.0', '1.0'];

  var $itemsLinks = $('.js-unsupported-versions-list .js-sub-menu-item-link');
  $itemsLinks.each(function() {
    var version = $(this).attr('aria-version');
    if (unsupportedVersions.indexOf(version) !== -1) {
      $(this).addClass('unsupported');
    }
  });

  var $unsupportNotification = $('.js-unsupport-notification');

  var $menuLinks = $('.js-menu-item-link--version');
  $menuLinks.each(function() {
    var currentVersion = $(this).attr('aria-version');
    if (unsupportedVersions.indexOf(currentVersion) !== -1) {
      $unsupportNotification.addClass('unsupported');
    }
  });

  var $searchOptions = $('.js-global-search-branch__option');
  $searchOptions.each(function() {
    var optionVersion = $(this).val();

    if (unsupportedVersions.indexOf(optionVersion) !== -1) {
      $(this).append(' (Unsupported SDK)');
    }
  });

  var $docsOutdatedWarning = $('.js-docs-outdated-warning');
  var $docsUnsupportedWarning = $('.js-docs-unsupported-warning');
  var currentVersionDoc = $('.top-menu-item.active .js-menu-item-link--version').attr('aria-version');

  if (unsupportedVersions.indexOf(currentVersionDoc) !== -1) {
    $docsUnsupportedWarning.removeClass('hide');
  } else {
    $docsOutdatedWarning.removeClass('hide');
  }
});

$(function() {
  //init iframes container for video scaling
  $('body iframe').each(function() {
    $(this).parent().addClass('video-container video-container-16x9');
  });
});

$(function() {
  var $userLoginDialog = $('#userLogin');
  var $userLoginForm = $userLoginDialog.find('form');
  var successCallback = null;

  $userLoginDialog.modal({
    show: false,
    keyboard: false,
    backdrop: 'static',
  }).find('.save-button').click(function() {
    $.ajax({
      'url': '/ajax/common/login',
      'type': 'post',
      'dataType': 'json',
      'data': $userLoginForm.serialize(),
      'success': function(answerData) {
        $userLoginForm.find('.alert').remove();

        if (answerData.result === 'error') {
          $('<div class="alert alert-error">' + answerData.message.value +
            '</div>').prependTo($userLoginForm);
        }
        else if (answerData.result === 'ok') {
          if (successCallback) {
            successCallback();
          }

          window.Unigine.hideLogin();
        }
      },
      'error': function(errorData, textStatus, errorThrown) {
        errorData['url'] = '/ajax/user/login';
        errorData['responseText'] = errorData['responseText'].length > 145 ?
          'long-response-cutted' :
          errorData['responseText'];

        throw new Error(JSON.stringify(errorData));
      },
    });
  });

  window.Unigine.showLogin = function(success) {
    successCallback = success;

    $userLoginDialog.modal('show');
  };

  window.Unigine.hideLogin = function() {
    successCallback = null;

    $userLoginDialog.modal('hide');
  };
});

$(function() {
  /* Search forms actions */
  $('#search-form-icon').on('click', function() {
    $(this).closest('form').submit();
  });
  
  var searchQuery = $('#search-query');
  var globalSearchQuery = $('#global-search-query');

  /* Focus the search field on load and open the sidebar, if closed */
  var sidebarBtn = $('.js-left-panel-opener');
  if (globalSearchQuery.length && !sidebarBtn.hasClass('open')) {
    sidebarBtn.click();
  }
  globalSearchQuery.focus();

  if (searchQuery.length) {
    globalSearchQuery.val(searchQuery.val());
    $('#global-search-form').submit(function(event) {
      event.preventDefault();

      searchQuery.val(globalSearchQuery.val());

      $('#search-form').submit();

      return false;
    });
  }

  var $category = $('#api-only-input');
  var categoryVal = $category.val();
  var $allCategoriesGlobalForm = $('#all-categories');
  var $allCategoriesTreeForm = $('#category-root');

  if (!globalSearchQuery.length) {
    return false;
  }
  var previousVal = '';
  var suggest = $('#suggest');

  var fieldPosition = globalSearchQuery.offset();
  var currentMenu = -1, totalMenu = 0;

  function highlightMenu(newMenuIndex, oldMenuIndex) {
    suggest.find('div.r:eq(' + newMenuIndex + ')').addClass('h');
    if (oldMenuIndex >= 0) {
      suggest.find('div.r:eq(' + oldMenuIndex + ')').removeClass('h');
    }
  }

  var $subCategories = $('.c-sub-category');

  //preventing checkboxes from stealing focus
  $category.mousedown(function (event) {
    // this would stop mousedown from continuing and would not focus
    event.preventDefault();
  });

  $category.change(function () {
    $allCategoriesGlobalForm.val(Number(!$(this).prop('checked')));
    $allCategoriesTreeForm.prop('checked', !$(this).prop('checked'));

    if ($(this).prop('checked')) {
      $subCategories.each(function () {
        if ($(this).val()===categoryVal) {
          return false;
        }

        $(this).prop('checked', !$category.prop('checked'));
      });
    }
  });

  $(document).click(function(e) {
    if (e.toElement === globalSearchQuery[0] || $(e.toElement).parents('#suggest').length >
        0) {
      return;
    }

    suggest.hide();
    suggest.find('> div.r').remove();
    currentMenu = -1;
  });

  globalSearchQuery.keydown(function(e) {
    var newMenu = 0;
    if (e.keyCode === 38 || (e.keyCode === 9 && e.shiftKey)) { //up
      newMenu = currentMenu - 1;
      if (newMenu < 0) {
        newMenu = totalMenu - 1;
      }

      highlightMenu(newMenu, currentMenu);
      currentMenu = newMenu;

      e.preventDefault();
      return false;
    }
    else if (e.keyCode === 40 || e.keyCode === 9) { //down
      newMenu = currentMenu + 1;
      if (newMenu >= totalMenu) {
        newMenu = 0;
      }

      highlightMenu(newMenu, currentMenu);
      currentMenu = newMenu;

      e.preventDefault();
      return false;
    }
    else if (e.keyCode === 27) { //esc
      suggest.hide();
      suggest.find('> div.r').remove();
      currentMenu = -1;

      e.preventDefault();
      return false;
    }
    else if (e.keyCode === 13 && currentMenu != -1) { //enter
      if (currentMenu === -1 || totalMenu === 0) {
        return;
      }

      var clickEvent = new MouseEvent('click', {
        'view': window,
        'bubbles': true,
        'cancelable': false,
      });
      suggest.find('div.r:eq(' + currentMenu + ') > a')[0].dispatchEvent(
          clickEvent);

      e.preventDefault();
      return false;
    }
  });

  globalSearchQuery.keyup(function(e) {
    var value = globalSearchQuery.val();

    if (value === '') {
      suggest.hide();
      suggest.find('> div.r').remove();
      currentMenu = -1;
      return;
    }
    
    if (previousVal === value) {
      return;
    }

    var sendData = {s: value, b: $('#global-search-branch').val()};

    if ($category.prop('checked')) {
      sendData.c = categoryVal;
    }

    $.ajax({
      url: '/' + window.currentLang + '/ajax/common/searchSuggest',
      data: sendData,
      type: 'post',
      dataType: 'json',
      success: function(data) {
        currentMenu = -1;

        suggest.find('> div.r').remove();

        totalMenu = Object.keys(data).length;

        if (Object.keys(data).length === 0) {
          suggest.hide();
        }
        else {
          suggest.show();
          for (var path in data) {
            if (!data.hasOwnProperty(path)) {
              continue;
            }

            $('<div>',{
              class: 'r',
              append: $('<span>', {
                class: 'label label-category-' + data[path].categoryId,
                text: data[path].category
              })
              .add('<a>', {
                text: data[path].title,
                href: data[path].url + '?rlang=' + (window.Unigine.getCookie('rlangDefaultState') || 'cpp'),
                on: {
                  click: function() {
                    saveSearchQuery();
                  }
              }})
            })
            .appendTo(suggest);
          }
        }
      },
    });

    previousVal = value;
  });

  $category.change(function(e) {
    var value = globalSearchQuery.val();

    if (value === '') {
      suggest.hide();
      suggest.find('> div.r').remove();
      currentMenu = -1;
      return;
    }

    var sendData = {s: value, b: $('#global-search-branch').val()};

    if ($category.prop('checked')) {
      sendData.c = categoryVal;
    }

    $.ajax({
      url: '/' + window.currentLang + '/ajax/common/searchSuggest',
      data: sendData,
      type: 'post',
      dataType: 'json',
      success: function(data) {
        currentMenu = -1;

        suggest.find('> div.r').remove();

        totalMenu = Object.keys(data).length;

        if (Object.keys(data).length === 0) {
          suggest.hide();
        }
        else {
          suggest.show();
          for (var path in data) {
            if (!data.hasOwnProperty(path)) {
              continue;
            }

            $('<div>',{
              class: 'r',
              append: $('<span>', {
                class: 'label label-category-' + data[path].categoryId,
                text: data[path].category
              })
              .add('<a>', {
                text: data[path].title,
                href: data[path].url + '?rlang=' + (window.Unigine.getCookie('rlangDefaultState') || 'cpp'),
              })
            })
            .appendTo(suggest);
          }
        }
      },
    });

    previousVal = value;
  });

  $(window).on('load resize scroll', function() {
    var scrollPosition = fieldPosition.top -
        (document.body.scrollTop + document.documentElement.scrollTop);
  });

  // save search action
  var searchForm = $('#search-form');
  if (searchForm.length === 0) {
    searchForm = $('#global-search-form');
  }

  function saveSearchQuery() {
    $.ajax({
      url: '/' + window.currentLang + '/ajax/common/saveSearchQuery',
      data: searchForm.serializeArray(),
      type: 'post',
      dataType: 'json'
    })
  }

  searchForm.submit(function() {
    saveSearchQuery();
  });
});

$(function() {
  /*go to hash cause ajax page may be loaded*/
  window.Unigine.scrollToAddressHash = function(hash, fixedHeaderOffset) {
    if (!hash) {
      hash = window.location.hash;
    }

    if (!fixedHeaderOffset) {
      fixedHeaderOffset = 0;
    }

    if (hash !== '') {
      var $element = $(hash);

      if ($element.length > 0) {
        $('html, body').animate({
          scrollTop: $element.offset().top - fixedHeaderOffset
        }, 500);
      }
    }
  };

  /*smooth scrolling for hashes and top button*/
  window.Unigine.smoothScrollInit = function() {
    var scrollElems = $('a[href*="#"]').not('.js-no-scroll, .scroll-init');
    scrollElems.addClass('scroll-init');

    scrollElems.on('click', function() {
      var href = $.attr(this, 'href') || '#';
      var posTop = 0;

      //check if href it is full link and not only anchor, do default action
      if (href.indexOf('/') >= 0) {
        return true;
      }

      if (href.indexOf('/') === -1 && $(href).length > 0) {
        posTop = $(href).offset().top;
      }

      $('html, body').animate({
        scrollTop: posTop
      }, 500, function () {
        window.location.hash = href;
      });

      return false;
    });
  };

  window.Unigine.smoothScrollInit();

  //time in milliseconds default - 1 year
  window.Unigine.setCookie = function(name, value, time) {
    var expires = new Date();
    if (!time) {
      time = 365 * 24 * 60 * 60 * 1000;
    } else {

    }

    expires.setTime(expires.getTime() + time);
    document.cookie = name + '=' + value + '; expires=' +
      expires.toUTCString() + '; path=/';
  };

  window.Unigine.deleteCookie  = function(name) {
    document.cookie = name + '=; Max-Age=-99999999; path=/';
  };

  window.Unigine.getCookie = function (name) {
    var val = document.cookie.match(new RegExp(name + '=([^;]+)'));

    if (val && val[1]) {
      return val[1];
    }

    return false;
  };

  window.Unigine.testCookie = function () {
    if (navigator.cookieEnabled) {
      return true;
    }
    document.cookie = 'cookietest=1';
    var result = document.cookie.indexOf('cookietest') !== -1;
    document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
    return result;
  };

  window.Unigine.getQueryParam = function(parameter) {
    var search = decodeURIComponent(location.search.substr(1)).split('&');
    var found;

    for (var searchPart in search) {
      if (!search.hasOwnProperty(searchPart)) {
        continue;
      }

      if (search[searchPart].indexOf(parameter + '=') === 0) {
        found = search[searchPart].split('=')[1];
        break;
      }
    }

    return found;
  }
  
  window.Unigine.removeQueryParam = function(parameter, queryString) {
    var queryParams = new URLSearchParams(queryString || window.location.search)
    queryParams.delete(parameter);

    var queryReturned = '';
    if (queryParams.toString()) {
      queryReturned = '?' + queryParams.toString();
    }

    return queryReturned;
  };

  window.Unigine.setQueryParam = function(parameter, value, queryString) {
    var queryParams = new URLSearchParams(queryString);
    queryParams.set(parameter, value);
    return queryParams.toString();
  }

  window.Unigine.checkLogin = function (callback) {
    var next = typeof callback === 'function' ? callback : function () {
    };
    var url = window.checkLoginUrl;
    var xmlHttp = new XMLHttpRequest();
    xmlHttp.open('GET', url);
    xmlHttp.withCredentials = true;
    xmlHttp.onreadystatechange = function (e) {
      if (xmlHttp.readyState === 4) {
        var loggedIn;
        var uid;
        try {
          var json = JSON.parse(xmlHttp.responseText);
          if (json && typeof json.logged_in === 'boolean') {
            loggedIn = json.logged_in;
            uid = json.user_id;
          } else {
            loggedIn = false;
          }
        } catch (e) {
          loggedIn = false;
        }
        next(loggedIn, uid);
      }
    };
    xmlHttp.send();
  };

  window.Unigine.checkAuthorization = function () {
    if (!window.Unigine.testCookie()) {
      return;
    }

    var tryLogin = window.Unigine.getCookie('try-login');

    if (!tryLogin) {
      window.Unigine.checkLogin(function (status, uid) {
        window.Unigine.setCookie('try-login', 1, 3600 * 1000);

        if (uid === window.currentUID) {
          return;
        }

        if (uid !== parseInt(window.currentUID, 10) && status) {
          window.location = '/login';
        }
      });
    }
  };

  window.Unigine.checkAuthorization();
});


